<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="small-panel" @click.stop>
                <div class="dialog-title" v-t="'message.title_add_edit_general_admin_user'">
                </div>
                <hr class="dialog-hr">
                <div class="dialog-body-small">
                    <el-form class="dialog-form-item" label-width="170px" >
                        <!--- ログインID --->
                        <el-form-item ref="userName" prop="userName">
                            <div slot="label" style="text-align:left">
                                <span>ログインID</span> <span class="required" v-t="'message.item_required'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-html="$t('message.hint_loginId_general_admin')"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <div class="login-id-field">
                                <el-input id="userName" size="large" type="text" :placeholder="$t('message.place_holder_input_text')" v-model="inputForm.userName.value" autocomplete="off"
                                    @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                    clearable @clear="InputCheckAll()" :disabled="editMode"/>
                                <span class="login-id-domain">{{ "@" + appData.loginId.split("@")[1] }}</span>
                            </div>
                        </el-form-item>
                        <!--- ユーザー表示名 --->
                        <el-form-item ref="displayName" prop="displayName">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_userDisplayName'"></span> <span class="required" v-t="'message.item_required'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-html="$t('message.hint_user_display_name_general_admin')"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-input id="displayName" size="large" type="text" :placeholder="$t('message.place_holder_input_text')" v-model="inputForm.displayName.value" autocomplete="off"
                                 @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                 clearable @clear="InputCheckAll()"/>
                        </el-form-item>
                        <!--- パスワード --->
                        <el-form-item ref="password" prop="password">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_password'"></span> <span v-if="!editMode" class="required" v-t="'message.item_required'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-html="$t('message.hint_password')"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                                <span style="position:relative">
                                    <button class="input-pass-check" type="button" @click="handleChangePasswordCheck()">{{ passwordShowHideButton }}</button>
                                </span>
                            </div>
                            <el-input id="password" size="large" :type="inputTypeOfPassword" :placeholder="$t('message.place_holder_input_text')" v-model="inputForm.password.value" autocomplete="new-password"
                                 @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                 @clear="InputCheckAll()" clearable/>
                        </el-form-item>
                        <!--- テナント管理権限 --->
                        <el-form-item style="text-align:right">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_tenant_management_permissions'"></span>
                            </div>
                            <el-switch
                                v-model="permissions.tenantManagement"
                                active-color="#5171cb"
                                @change="handleOptionChange()"
                                :disabled="!appData.tenantAdminUser">

                            </el-switch>
                        </el-form-item>
                        <!-- チェックボックス　動態管理の参照 -->
                        <el-form-item style="text-align:right">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_reference_for_location_tracking'"></span>
                                <el-tooltip effect="dark" placement="top-start" style="padding-left: 5px">
                                    <div slot="content" style="text-align:left" v-html="$t('message.error_radio_integrate_general_admin_hint_consnole_permission_tracking')"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-switch
                                v-model="permissions.consoleManagementTracking"
                                active-color="#5171cb"
                                :disabled="!appData.tenantAdminUser && !appData.radioIntegratePermission.consoleManagementTracking"
                            ></el-switch>
                        </el-form-item>
                        <!--- コンソール操作権限 --->
                        <!-- チェックボックス　ユーザー、グループの作成 -->
                        <el-form-item style="text-align:left">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_console_operation_permissions'"></span>
                            </div>
                            <el-checkbox
                                v-model="permissions.consoleManagementEditUserAndTalkGroupDefinition"
                                :disabled="!appData.tenantAdminUser && !appData.radioIntegratePermission.consoleManagementEditUserAndTalkGroupDefinition"
                            >
                                {{ $t('message.item_create_user_group') }}
                            </el-checkbox>
                            <el-tooltip effect="dark" placement="top-start" style="padding-left: 5px">
                                <div slot="content" style="text-align:left" v-html="$t('message.error_radio_integrate_general_admin_hint_consnole_permission_edit_user_and_group_definition')"></div>
                                <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                            </el-tooltip>
                        </el-form-item>
                        <!-- チェックボックス　ユーザーをグループに追加 -->
                        <el-form-item style="text-align:left">
                            <div slot="label" style="text-align:left"></div>
                            <el-checkbox
                                v-model="permissions.consoleManagementEditUserTalkGroupAssignment"
                                :disabled="!appData.tenantAdminUser && !appData.radioIntegratePermission.consoleManagementEditUserTalkGroupAssignment"
                            >
                                {{ $t('message.item_edit_user_talk_group') }}
                            </el-checkbox>
                            <el-tooltip effect="dark" placement="top-start" style="padding-left: 5px">
                                <div slot="content" style="text-align:left" v-html="$t('message.error_radio_integrate_general_admin_hint_consnole_permission_edit_user_talkgroup_assignment')"></div>
                                <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                            </el-tooltip>
                        </el-form-item>
                        <!--- 無線機操作権限 --->
                        <!-- チェックボックス　無線機設定の管理 -->
                        <el-form-item style="text-align:left">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_radio_operation_permissions'"></span>
                            </div>
                            <el-checkbox
                                v-model="permissions.radioManagementEditRadioSettingDefinition"
                                @change="onRadioManagementDefinitionChange"
                                :disabled="!appData.radioManageUser && !appData.radioIntegratePermission.radioManagementEditRadioSettingDefinition"
                            >
                                {{ $t('message.item_management_of_radio_settings') }}
                            </el-checkbox>
                            <el-tooltip effect="dark" placement="top-start" style="padding-left: 5px">
                                <div slot="content" style="text-align:left" v-html="$t('message.error_radio_integrate_general_admin_hint_radio_permission_edit_radio_setting_definition')"></div>
                                <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                            </el-tooltip>
                        </el-form-item>
                        <!-- チェックボックス　無線機設定のWiFi項目の編集 -->
                        <el-form-item style="text-align:left">
                            <div slot="label" style="text-align:left"></div>
                            <div style="margin-left: 24px; padding-left: 12px; border-left: 2px solid #409EFF;">
                                <el-checkbox
                                    v-model="permissions.radioManagementEditRadioSettingWifiItemsDefinition"
                                    :disabled="permissions.radioManagementEditRadioSettingDefinition || (!appData.radioManageUser && !appData.radioIntegratePermission.radioManagementEditRadioSettingWifiItemsDefinition)"
                                >
                                    {{ $t('message.item_edit_wifi_of_radio_settings') }}
                                </el-checkbox>
                                <el-tooltip effect="dark" placement="top-start" style="padding-left: 5px">
                                    <div slot="content" style="text-align:left" v-html="$t('message.error_radio_integrate_general_admin_hint_radio_permission_edit_radio_setting_wifi_items_definition')"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                        </el-form-item>
                        <!-- チェックボックス　無線機設定の割り当ての管理 -->
                        <el-form-item style="text-align:left">
                            <div slot="label" style="text-align:left"></div>
                            <el-checkbox
                                v-model="permissions.radioManagementEditRadioSettingAssignment"
                                :disabled="!appData.radioManageUser && !appData.radioIntegratePermission.radioManagementEditRadioSettingAssignment"
                            >
                                {{ $t('message.item_assigned_of_radio_settings') }}
                            </el-checkbox>
                            <el-tooltip effect="dark" placement="top-start" style="padding-left: 5px">
                                <div slot="content" style="text-align:left" v-html="$t('message.error_radio_integrate_general_admin_hint_radio_permission_edit_radio_setting_assignment')"></div>
                                <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                            </el-tooltip>
                        </el-form-item>
                        <!-- チェックボックス　無線機の表示項目の編集 -->
                        <el-form-item style="text-align:left">
                            <div slot="label" style="text-align:left"></div>
                            <el-checkbox
                                v-model="permissions.radioManagementEditRadioUserDisplayItemsDefinition"
                                :disabled="!appData.radioManageUser && !appData.radioIntegratePermission.radioManagementEditRadioUserDisplayItemsDefinition"
                            >
                                {{ $t('message.item_edit_radio_display_name_permission') }}
                            </el-checkbox>
                            <el-tooltip effect="dark" placement="top-start" style="padding-left: 5px">
                                <div slot="content" style="text-align:left" v-html="$t('message.error_radio_integrate_general_admin_hint_radio_permission_edit_radio_user_dispaly_items_definition')"></div>
                                <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                            </el-tooltip>
                        </el-form-item>
                        <!--- 作成時に階層権限を付与 --->
                        <el-form-item v-if="!editMode" style="text-align:left">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_grant_level_permissions_at_the_creation'"></span>
                            </div>
                            <el-select class="select-option-item" v-model="permissions.grantLevelPermissionsAtCreation" @change="handleOptionChange()">
                                <el-option v-for="grantLevelPermission in grantLevelPermissionsList" :key="grantLevelPermission.type" :label="grantLevelPermission.displayName" :value="grantLevelPermission.type" :disabled="grantLevelPermissionsList.length === 1"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
                    <el-button class="dialog-ok-button" @click="addUser" :disabled="this.$data.disableButton" v-t="'message.button_save'"></el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import commonValidate from '@/components/common-validate.js';
import commonUtil from '@/components/commonutil.js';
import constants from "../../../constants";
import appData from "../../AppData.vue";

export default {
    data() {
        return {
            inputForm: {
                userName:       { validationRule: "userId",           valid: false,   value: null,   isComposing: false },
                displayName:    { validationRule: "reqDisplayName",   valid: false,   value: null,   isComposing: false },
                password:       { validationRule: "password",         valid: false,   value: null,   isComposing: false }
            },
            permissions: {
                // テナント管理権限
                tenantManagement: false,
                // コンソール操作権限
                consoleManagementEditUserAndTalkGroupDefinition: false,
                consoleManagementEditUserTalkGroupAssignment: false,
                consoleManagementTracking: false,
                // 無線機操作権限
                radioManagementEditRadioSettingDefinition: false,
                radioManagementEditRadioSettingAssignment: false,
                radioManagementEditRadioSettingWifiItemsDefinition: false,
                radioManagementEditRadioUserDisplayItemsDefinition: false,
                // 階層権限
                grantLevelPermissionsAtCreation: constants.GRANT_LEVEL_PERMISSION.NONE,
            },
            inputTypeOfPassword: "password",
            passwordShowHideButton: "SHOW",
            disableButton: true,
            grantLevelPermissionsList: [],
        };
    },
    methods: {
        addUser() {
            let params = {
                userName: this.$data.inputForm.userName.value,
                displayName: this.$data.inputForm.displayName.value,
                password: this.$data.inputForm.password.value,
                permissions: this.permissions
            };

            if (this.editMode) {
                params.id = this.initialData.id;
            }

            this.$emit('save', params);
        },
        handleOptionChange() {
            this.setButtonStatus();
        },
        handleChangePasswordCheck() {
            if (this.inputTypeOfPassword == "password") {
                this.inputTypeOfPassword = "text";
            } else {
                this.inputTypeOfPassword = "password";
            }
        },
        setButtonStatus: function() {
            if (commonValidate.checkFormValidation(this.inputForm)) {
                this.disableButton = false;
            } else {
                this.disableButton = true;
            }
        },
        inputCheck(eventTargetId) {
            if (this.inputForm[eventTargetId].isComposing) {
                // inputting with IME
                return;
            }
            let validateResult;
            validateResult = commonValidate.validateItem(this.$i18n, this.inputForm[eventTargetId].validationRule, this.inputForm[eventTargetId].value);
            if (validateResult.valid) {
                this.inputForm[eventTargetId].valid = true;
                this.$refs[eventTargetId].clearValidate();
            } else {
                this.inputForm[eventTargetId].valid = false;
                this.$refs[eventTargetId].validateState = "error";
                this.$refs[eventTargetId].validateMessage = validateResult.message;
            }
            this.setButtonStatus();
        },
        InputCheckAll() {
            for (let targetId in this.inputForm) {
                if (this.editMode && targetId === 'userName') {
                    continue;
                }
                this.inputCheck(targetId);
            }
        },
        compositionStart(eventTargetId) {
            this.inputForm[eventTargetId].isComposing = true;
        },
        compositionEnd(eventTargetId) {
            this.inputForm[eventTargetId].isComposing = false;
            this.inputCheck(eventTargetId)
        }
    },
    watch: {
        inputTypeOfPassword(newVal) {
            if (newVal == "password") {
                this.passwordShowHideButton = "SHOW";
            } else {
                this.passwordShowHideButton = "HIDE";
            }
        },

        'permissions.consoleManagementEditUserAndTalkGroupDefinition'(newVal) {
            if (newVal) {
                // 動態管理の参照は他の権限とは併用できないため、ONにした時に動態管理の参照権限をOFFにする
                this.permissions.consoleManagementTracking = false;
            }
            this.setButtonStatus();
        },

        'permissions.consoleManagementEditUserTalkGroupAssignment'(newVal) {
            if (newVal) {
                // 動態管理の参照は他の権限とは併用できないため、ONにした時に動態管理の参照権限をOFFにする
                this.permissions.consoleManagementTracking = false;
            }
            this.setButtonStatus();
        },

        onRadioManagementDefinitionChange: function(value) {
            if (value) {
                this.permissions.radioManagementEditRadioSettingWifiItemsDefinition = true;
            }
        },

        'permissions.consoleManagementTracking'(newVal) {
            if (newVal) {
                // 動態管理の参照は他の権限とは併用できないため、ONにした時に全ての他の権限をOFFにする
                this.permissions.tenantManagement = false;
                this.permissions.consoleManagementEditUserAndTalkGroupDefinition = false;
                this.permissions.consoleManagementEditUserTalkGroupAssignment = false;
                this.permissions.radioManagementEditRadioSettingDefinition = false;
                this.permissions.radioManagementEditRadioSettingAssignment = false;
                this.permissions.radioManagementEditRadioSettingWifiItemsDefinition = false;
                this.permissions.radioManagementEditRadioUserDisplayItemsDefinition = false;
            }
            this.setButtonStatus();
        },

        'permissions.radioManagementEditRadioSettingDefinition'(newVal) {
            if (newVal) {
                // 動態管理の参照は他の権限とは併用できないため、ONにした時に動態管理の参照権限をOFFにする
                this.permissions.consoleManagementTracking = false;

                // 無線機設定のWifi項目の編集権限はこの権限に内包されるのでOFFにする
                this.permissions.radioManagementEditRadioSettingWifiItemsDefinition = false;
            }
            this.setButtonStatus();
        },

        'permissions.radioManagementEditRadioSettingAssignment'(newVal) {
            if (newVal) {
                // 動態管理の参照は他の権限とは併用できないため、ONにした時に動態管理の参照権限をOFFにする
                this.permissions.consoleManagementTracking = false;
            }
            this.setButtonStatus();
        },

        'permissions.radioManagementEditRadioSettingWifiItemsDefinition'(newVal) {
            if (newVal) {
                // 動態管理の参照は他の権限とは併用できないため、ONにした時に動態管理の参照権限をOFFにする
                this.permissions.consoleManagementTracking = false;

                // この権限は無線機管理の編集に内包されるのでOFFにする
                this.permissions.radioManagementEditRadioSettingDefinition = false;
            }
            this.setButtonStatus();
        },

        'permissions.radioManagementEditRadioUserDisplayItemsDefinition'(newVal) {
            if (newVal) {
                // 動態管理の参照は他の権限とは併用できないため、ONにした時に動態管理の参照権限をOFFにする
                this.permissions.consoleManagementTracking = false;
            }
            this.setButtonStatus();
        },

    },

    computed: {},

    mounted: function() {
        // tabIndex of tooltip was always set to 0 (Should set -1 to skip focus)
        for (let element of document.getElementsByClassName('icon-help')) {
            element.setAttribute("tabIndex", "-1");
        }
    },
    props: ['appData', 'editMode', 'initialData'],
    created: function() {
        console.log(this.appData)

        let self = this;
        this.grantLevelPermissionsList = commonUtil.getConsoleOperationPermissions(this.$i18n)
            .filter(permission => permission.type <= self.appData.rootNodePermission);
        if (this.editMode && this.initialData) {
            this.inputForm.userName.value = this.initialData.userName;
            this.inputForm.displayName.value = this.initialData.displayName;
            this.inputForm.userName.valid = true;
            this.inputForm.displayName.valid = true;

            // パスワードは必須ではない（変更する場合のみ入力）
            this.inputForm.password.validationRule = "passwordOrEmpty";
            this.inputForm.password.valid = true;

            if (this.initialData.permissions) {
                Object.assign(this.permissions, this.initialData.permissions);
            }
            this.setButtonStatus();
        }
    },
}
</script>

<style scoped>
button.input-pass-check {
    border-style: none;
    background-color: #fff;
    cursor: pointer;
    outline: none;
    position: absolute;
    height: 20px;
    width: 44px;
    left: 270px;
    top: 2px;
    font-size: 10px;
    z-index: 10;
    color: #848991;
}
.login-id-field {
    display: flex;
    align-items: center;
    gap: 8px;
}

.login-id-field .el-input {
    width: 210px;
}

.login-id-domain {
    color: #606266;
    white-space: nowrap;
    font-size: 14px;
}
</style>
